import * as React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { setCategories } from "../slice/search-slice";
import { categoryFactory } from "../factories/category-factory";
import { ItemDetail } from "./item-detail";
import { Category } from "../model/search-base-model";

interface SearchAppProps {
  initialDataLoad: (dispatch: Dispatch<any>) => void;
  renderItem: (item: any) => JSX.Element;
  renderSearchList: (renderItem: (item: any) => JSX.Element) => JSX.Element;
  filters: JSX.Element;
  categoryFactory?: { [key: string]: Category[] };
}

export function SearchApp(props: SearchAppProps) {
  const { renderItem, initialDataLoad } = props;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCategories(props.categoryFactory || categoryFactory()));
    initialDataLoad(dispatch);
  }, []);

  return (
    <>
      {props.filters}
      {props.renderSearchList(renderItem)}
      <ItemDetail />
    </>
  );
}
